<template>
    <td>
        <div class="d-flex align-center">
            <v-progress-linear
                :value="value"
                height="25"
                rounded
                :dark="dark"
                :color="getColor()"
                style="width: 100px; margin-right: 10px;"
            ></v-progress-linear>
            <strong :style="{ color: getTextColor() }">{{ value }}%</strong>
        </div>
    </td>
</template>

<script>

export default {
    name: "PercentItem",
    props: {
        value: {
            required: true
        },
        paint: {
            type: String,
            required: false,
            default: null,
        },
        upperThreshold: {
            type: Number,
            required: false,
            default: 50
        },
        lowerThreshold: {
            type: Number,
            required: false,
            default: 25
        },
        dark: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        getColor() {
            if (!this.paint) {
                return this.dark ? "white" : "primary";
            }

            if (this.value >= this.lowerThreshold && this.value <= this.upperThreshold) {
                return this.dark ? "orange-lighten-2" : "orange";
            }

            if (this.paint === "min") {
                if (this.value >= this.upperThreshold) {
                    return this.dark ? "red-lighten-2" : "red";
                } else {
                    return this.dark ? "green-lighten-2" : "green";
                }
            }

            if (this.paint === "max") {
                if (this.value <= this.lowerThreshold) {
                    return this.dark ? "red-lighten-2" : "red";
                } else {
                    return this.dark ? "green-lighten-2" : "green";
                }
            }

            return this.dark ? "white3" : "primary";
        },
        getTextColor() {
            if (this.dark) {
                return "white";
            }
            return this.getColor();
        }
    }
}

</script>

<style scoped>
/* Dark mode specific styles */
.v-progress-linear--dark {
    background-color: rgba(255, 255, 255, 0.12) !important;
}

.v-progress-linear--dark .v-progress-linear__background {
    background-color: rgba(255, 255, 255, 0.12) !important;
}
</style>